export default {
  language: "ภาษาอังกฤษ",
  // 导航
  zdy: {
    tjsq: "ส่งใบสมัคร",
    czsl: "เติมเงินจำนวน",
    enterczsl: "กรุณากรอกจำนวนเงินที่เติม",
    qbdz: "กระเป๋าเงิน",
    enterqbdz: "กรุณากรอกที่อยู่กระเป๋าเงิน",
    sftjmcj: "ส่งคำสั่งราคาขาย",
    sftjmrj: "ส่งคำสั่งราคาซื้อ",
    proloss: "หยุด",
  },
  header: {
    home: "บ้าน",
    markets: "ตลาด",
    fiat: "Fiat",
    c2c: "C2C",
    exchange: "แลกเปลี่ยน",
    lever: "โยกย้าย",
    micro: "สัญญการซื้อขายาครั้งที่สอง",
    myshop: "ร้านค้า",
    assets: "ทรัพย์สิน",
    help: "ช่วยเหลือ",
    login: "เข้าสู่ระบบ",
    sign: "ลงชื่อ",
    accountSet: "บัญชี",
    tradeLog: "บันทึกการทำธุรกรรม",
    receiveSet: "ของสะสม ",
    identify: "การตรวจสอบสิทธิ์",
    jchange: "แลกเปลี่ยน",
    logout: "ออกจากระบบ",
    themedark: "โหมดกลางคืน",
    themeday: "โหมดกลางวัน",
  },
  // 登录注册
  lg: {
    login: "เข้าสู่ระบบ",
    register: "ลงชื่อ",
  },
  // 首页
  home: {
    vol: "ตลอด24ชั่วโมง",
    c01: "แพลตฟอร์มการซื้อขายสินทรัพย์ดิจิทัลชั้นนำของโลก",
    c02: "ให้บริการซื้อขายสินทรัพย์ดิจิทัลและการจัดการสินทรัพย์ที่ปลอดภัยและเชื่อถือได้แก่ผู้ใช้หลายล้านคนในกว่า 130 ประเทศทั่วโลก",
    c03: "ปลอดภัยและเชื่อถือได้",
    c04: "ประสบการณ์ 5 ปี ด้านบริการทางการเงินสินทรัพย์ดิจิทัล",
    c05: "สถาปัตยกรรมแบบกระจายมืออาชีพและระบบการต่อต้าน การโจมตีแบบ DDOS",
    c06: "เค้าโครงระบบนิเวศทั่วโลก",
    c07: "มีหลายประเทศตั้งศูนย์บริการธุรกรรมที่แปลเป็นภาษาท้องถิ่น ",
    c08: "เพื่อสร้างระบบนิเวศบล็อคเชนที่มีรูปแบบธุรกิจที่หลากหลาย",
    c09: "ดูแลและใส่ใจลูกค้า",
    c10: "กำหนดกลไกการชำระเงินล่วงหน้า",
    c11: "ตั้งกองทุนคุ้มครองผู้ลงทุน",
    c12: "การซื้อขายเทอร์มินัลหลายแพลตฟอร์มทุกที่ทุกเวลา",
    c13: "ครอบคลุมหลายแพลตฟอร์มของ iOS, Android, Windows และรองรับฟังก์ชันทางธุรกิจเต็มรูปแบบ",
    sweep: "สแกนรหัสดาวน์โหลด",
    android: "แอนดรอยน์",
    pinput: "กรุณากรอกอีเมลหรือหมายเลขโทรศัพท์มือถือของคุณ",
    atrade: "ลงทะเบียนบัญชี Besencexchange และเริ่มการซื้อขาย",
    download: "ดาวน์โหลดแอป",
  },
  // 底部
  foo: {
    about: "เกี่ยวกับเรา",
    support: "การสนับสนุนผู้ใช้",
    contact: "ติดต่อเรา",
    qq: "QQ",
    email: "อีเมล",
    usdt: "ตลาด",
    footlefta: "ประกาศทางกฎหมาย",
    footleftb: "นโยบายความเป็นส่วนตัว",
    footleftc: "ข้อตกลงการใช้",
    footmidd: "เกี่ยวกับการต่อต้านการฟอกเงิน",
    footmide: "กฎการซื้อขายสัญญาถาวร",
    footrightf: "ดาวน์โหลด",
    footrightg: "ดาวน์โหลดแอนดรอยด์",
  },
  // 行情
  market: {
    handicap: "แฮนดิแคป",
    exchange: "แลกเปลี่ยน",
    selfmarket: "รายการโปรด",
    allmarket: "ทั้งหมด",
    symbol: "คู่",
    newprice: "ราคาล่าสุด",
    change: "เปลี่ยนแปลง",
    highprice: "สูงสุด",
    lowprice: "ต่ำสุด",
    vol: "ตลอด24 ช.ม.",
  },
  // 公共交易
  td: {
    buy: "ซื้อ",
    sell: "ขาย",
    currency: "สกุลเงิน",
    num: "ตัวเลข",
    time: "เวลา",
    limit: "ขีดจำกัด",
    price: "ราคาต่อหน่วย",
    method: "วิธีชำระเงิน",
    total: "รวม",
    inwant: "กรุณากรอกข้อมูล",
    do: "การดำเนินการ",
    more: "โหลดเพิ่มเติม",
    nomore: "ไม่มี",
    nodata: "ไม่มีข้อมูล",
    trade: "ซื้อขาย",
    buynum: "ปริมาณการซื้อ",
    sellout: "ขาย ",
    buyin: "ซื้อ ",
    all: "ทั้งหมด",
    allbuy: "ซื้อทั้งหมด",
    allsell: "ขายทั้งหมด",
    buytotal: "กรุณาระบุยอดรวมที่ท่านต้องการซื้อ.",
    selltotal: "กรุณาระบุจำนวนเงินที่ต้องการขาย.",
    buyallnum: "กรุณาระบุจำนวนที่ต้องการซื้อ.",
    sellallnum: "กรุณาระบุจำนวนที่ต้องการขาย.",
    tradeTotal: "ปริมาณธุรกรรมทั้งหมด",
    doceil: "ยกเลิกโดยอัตโนมัติในไม่กี่วินาที",
    place: "สั่งซื้อสินค้า",
    waitpay: "รอดำเนินการชำระเงิน",
    paycode: "รหัสการชำระเงิน",
    finished: "เสร็จสิ้น",
    ceiled: "ยกเลิก",
    payed: "จ่าย",
    nofinish: "ไม่สมบูรณ์",
    buyer: "ผู้ซื้อ",
    seller: "ผู้ขาย",
    callWay: "ช่องทางการติดต่อ",
    placeTime: "เวลาสั่งซื้อ",
    renum: "หมายเลขอ้างอิง",
    canceil: "ยกเลิก",
    confirm: "ยืนยัน",
    pwd: "กรุณาใส่รหัสผ่านการทำธุรกรรม.",
    coincode: "หน่วยการเงิน",
    pcoin: "กรุณาเลือกหน่วยเงินตรา.",
  },
  // 法币交易
  fat: {
    // LegalPayDetail
    orderLog: "บันทึกการสั่งซื้อ",
    fatdLog: "ทะเบียนการค้าทางกฎหมาย",
    shoper: "ธุรกิจ",
    faLog: "ทะเบียนการค้าทางกฎหมาย",
    tdType: "ประเภทธุรกรรม",
    odStatus: "สถานะการสั่งซื้อ",
    pwaitPay: "กรุณารอผู้ซื้อชำระเงิน",
    odFinish: "เสร็จสิ้นการสั่งซื้อ",
    odCeil: "คำสั่งซื้อถูกยกเลิก",
    odPay: "ชำระเงินเรียบร้อยแล้ว กรุณาตรวจสอบข้อมูลการชำระเงิน",
    tdCeil: "ยกเลิกธุรกรรม",
    pCeil: "หากคุณชำระเงินแล้ว ห้ามิให้ทำการยกเลิก",
    paySure: "ยืนยันการชำระเงิน",
    pdopay: "โปรดยืนยันว่าคุณได้ชำระเงินแล้ว",
    badClick: "การกระทำที่เป็นอันตรายและส่งผลต่อระบบจะทำให้บัญชีหยุดชะงัก",
    receivePay: "ใบเสร็จยืนยัน",
    payReceive: "โปรดยืนยันว่าผู้ซื้อได้ชำระเงินให้คุณแล้ว",
    receivePays: "การยืนยันลูกหนี้",
    // LegalPay
    payPlease: "กรุณาชำระเงิน",
    tdPrice: "ราคาต่อหน่วย",
    tdNum: "ปริมาณการทำธุรกรรม",
    payinfo: "ข้อมูลการชำระเงิน",
    banknum: "บัญชีธนาคาร",
    realName: "ชื่อจริง",
    shoperZname: "สาขาย่อยของผู้ค้า",
    shoperNum: "บัญชีการค้า",
    odCeil: "ยกเลิกคำสั่งซื้อ",
    imPay: " ยืนยัน ชำระเงินแล้ว",
    // LegalSeller
    register_time: "เวลาลงทะเบียน",
    odtotal: "เอกสารการประกอบ",
    odmonth: "แผ่นงาน 30 วัน",
    odfinish: "ใบเสร็จ",
    odrate: "อัตราสำเร็จ",
    submit: "เผยแพร่",
    phone: "โทรศัพท์",
    mysell: "การขายของฉัน",
    mybuy: "การซื้อของฉัน",
    realAuth: "การตรวจสอบชื่อจริง",
    advAuth: "การตรวจสอบขั้นสูง",
    linebuy: "การซื้อออนไลน์",
    linesell: "การขายออนไลน์",
    tipPay:
      "โปรดติดต่อร้านค้าเพื่อชำระเงินภายใน 24 ชั่วโมง หากการชำระเงินเกิน 24 ชั่วโมง จะถูกยกเลิกโดยอัตโนมัติ",
    notlow: "ไม่น้อยกว่าขีดจำกัดขั้นต่ำ",
    nothigh: "ไม่เกินขีด จำกัด สูงสุด",
    notnum: "ไม่เกินปริมาณสูงสุด",
    // LegalShopDetail
    type: "รูปแบบ",
    status: "สถานะ",
    seeOrder: "ดูคำสั่งซื้อ",
    withdraw: "ถอน",
    abnormal: "ผิดปกติ",
    lowershelf: "ขั้นต่ำ",
    protection: "การคุ้มครองสิทธิ",
    apply: "ใช้การคุ้มครองสิทธิ์",
    psType: "กรุณาเลือกประเภท",
    pselect: "โปรดเลือก",
    alipay: "อาลีเพย์",
    wechat: "วีแชท",
    bank: "บัตรเครดิตธนาคาร",
    minNum: "ปริมาณการซื้อขายขั้นต่ำ",
    maxNum: "ปริมาณการซื้อขายสูงสุด",
    wantBuy: "ต้องการซื้อ",
    pnums: "กรุณาใส่จำนวน",
    pmin: "กรุณากรอกปริมาณการทำธุรกรรมขั้นต่ำ",
    pmax: ",กรุณากรอกปริมาณการซื้อขายสูงสุด",
    pnot: "ปริมาณการซื้อขายสูงสุดไม่ควรน้อยกว่าปริมาณการซื้อขายขั้นต่ำ",
    // MyLegalShops
    myshops: "ร้านค้าส่วนตัว",
    name: "ชื่อ",
    fiatSub: "การประกวดราคาตามกฎหมาย",
    shoper_balance: "ยอดดุลการค้า",
    enterShop: "เข้าร้าน",
    // shop_legal_pay_detail
    payedWait: "ชำระเงินแล้วรอการตรวจสอบ",
    yes: "ใช่",
    no: "ไม่",
    sd: "ล็อคความสมดุล",
    journal: "บันทึกยอดคงเหลือ",
    business: "ธุรกิจ",
    user: "ชื่อผู้ใช้",
    backdone: "ถอนตัว",
    busbalance: "ยอดดุลการค้า",
    userbalance: "ยอดผู้ใช้",
  },
  ctc: {
    ctc: "C2C",
    myRelease: "การเปิดตัวของ C2C",
    myTrade: "C2C ซื้อขาย",
    and: "ใช่",
    balance: "สมดุล",
    buynum: "ซื้อฉบับที่",
    sellnum: "ขายฉบับที่",
    bankTransfer: "โอนเงินผ่านธนาคาร",
    payim: "ต้องจ่ายโดยตนเอง",
    pbuyNum: "ป้อนปริมาณการซื้อ",
    pprice: "กรุณาใส่ราคาต่อหน่วย",
    payway: "โปรดเลือกวิธีการชำระเงิน",
    psellNum: "กรุณาระบุจำนวนที่ขาย.",
    suerePlace: "คุณยืนยันการสั่งซื้อหรือไม่",
    detail: "รายละเอียด",
    payinfo: "ข้อมูลการชำระเงิน",
    Payee: "ผู้รับเงิน",
    total: "รวม",
    name: "ชื่อ",
    cardnum: " หมายเลขบัตร",
    receivePay: "การยืนยันลูกหนี้",
    ceilConfirm: "ยืนยันยกเลิกรายการ?",
    paySeller:
      "โปรดยืนยันว่าคุณได้ชำระเงินให้กับผู้ขาย การกรอกข้อมูลที่ไม่ถูกต้องจะทำให้บัญชีหยุดทำงาน",
    payBuyer: "โปรดยืนยันว่าคุณได้รับข้อมูลการชำระเงินจากผู้ซื้อ",
    account: "หมายเลขบัญชี",
    sellerPay: "โปรดยืนยันว่าผู้ซื้อได้ชำระเงินให้คุณแล้ว?",
    payattion:
      "โปรดชำระเงินให้กับผู้ขายโดยเร็วที่สุดหลังจากยืนยันการชำระเงิน การกรอกข้อมูลที่ไม่ถูกต้องจะทำให้บัญชีหยุดชะงัก",
    log: "c2c เสร็จสิ้นการสั่งซื้อ",
  },
  // 合约
  lever: {
    nowentrust: "เปิดรับออร์เดอร์",
    hisentrust: "ประวัติการสั่งซื้อ",
    lvchi: "ตำแหน่งเลเวอเรจ",
    all: "ทั้งหมด",
    or: "หรือ",
    gotrade: "เริ่มซื้อขาย",
    tdrecord: "บันทึกการทำธุรกรรม",
    dealed: ",เสร็จสมบูรณ์",
    notdeal: "ไม่ตกลง",
    loading: "กำลังโหลด",
    entotal: "จำนวนเงินที่ได้รับมอบหมายทั้งหมด",
    canuse: "มีอยู่ ",
    xtd: "จำกัด",
    pprice: "กรุณาใส่ราคา",
    phand: "กรุณาป้อนจำนวนการซื้อ",
    phandsell: "กรุณาใส่จำนวนมือที่ขาย",
    pwd: "รหัสผ่าน",
    ppwd: "กรุณาป้อนรหัสผ่านการทำธุรกรรม",
    psw: "รหัสผ่านการทำธุรกรรม",
    equal: "เท่ากับ",
    times: "เวลา",
    timed: "รายการ",
    hand: "มือ",
    hands: "มือ",
    ptimes: "กรุณาเลือกรายการ",
    phands: "กรุณาเลือกจำนวนมือ",
    contractVal: "มูลค่าตลาดตามสัญญา",
    bail: "มาร์จิ้น",
    canBail: "อัตรากำไรขั้นต้นที่มีอยู่",
    charge: "ค่าบริการการทำธุรกรรม",
    domore: "ซื้อ (ระยะยาว)",
    doshort: "ขาย (ระยะสั้น)",
    dmore: "ระยะยาว",
    dshort: "ระยะสั้น",
    sureOd: "ยืนยันรายการ",
    noless: "จำนวนมือต้องไม่ต่ำกว่า",
    nomore: "จำนวนมือต้องไม่เกิน",
    tdnum: "รวม",
    risk: "อัตราความเสี่ยง",
    allloss: "กำไรขาดทุนรวมของ",
    onehouse: ",ปุ่มเดียวปิด",
    type: "รูปแบบ",
    entrustPrice: "ค่าคอมมิชชั่น",
    openPrice: "ราคาเปิด",
    nowPrice: "ราคาปัจจุบัน",
    styPrice: "ราคากำไร",
    stsPrice: "ราคาหยุดขาดทุน",
    openTime: "เวลาเปิด",
    closeTime: "เวลาปิด",
    rate: "ค่าธรรมเนียมการจัดการ",
    nightFee: "ค่าธรรมเนียมข้ามวัน",
    loss: "กำไรและขาดทุน",
    setloss: "ตั้งหยุดขาดทุน หยุดขาดทุน",
    expectProfit: "กำไรที่คาดหวัง",
    expectLoss: "คาดว่าจะขาดทุน",
    allClose: "ปิดทั้งหมด",
    moreClose: "แบนมากกว่าหนึ่งเท่านั้น",
    nullClose: "ว่างแค่หนึ่งเท่านั้น",
    sureClose: "ยืนยันตำแหน่ง ",
    thanZearo: "ค่าต้องมากกว่า 0",
    listin: "คำสั่งซื้อที่รอดำเนินการ",
    tdin: "ในการทำธุรกรรม",
    closein: "ปิดตำแหน่ง",
    closed: "ปิด",
    revoked: "เพิกถอน",
    revokeOrder: "คุณแน่ใจหรือว่าจะยกเลิกคำสั่งซื้อ? ",
    ping: "ปิดตำแหน่ง",
    revoke: ",ยกเลิก",
    sureping: "กำหนดการปิดหรือไม่？",
    thanzone: "ชุดค่าต้องมากกว่า 0",
  },
  // 币币
  cuy: {
    direction: "ทิศทาง",
    total: "ทั้งหมด",
    price: "ราคา",
    sell: "ขาย",
    buy: "ซื้อ",
    allStation: "การซื้อขายในตลาด",
    buyPrice: "ราคา",
    buynum: "จำนวน",
    sellPrice: "ราคา",
    sellnum: "จำนวน",
    tdPrice: "รวม",
    or: "หรือ",
    tdStart: "เริ่มซื้อขาย",
    pbPrice: "กรุณาใส่ราคาเสนอ",
    pbNum: "กรุณาป้อนจำนวนเงินที่ซื้อ",
    psPrice: "กรุณาใส่ราคาขาย",
    psNum: "กรุณาป้อนยอดขาย",
    fixPrice: "จำกัด",
    Mtrans: "ตลาด",
    available: "มีอยู่",
    revoke: "เลิกทำ",
    loading: "กำลังโหลด",
    confirmCancel: "คุณแน่ใจหรือว่าต้องการยกเลิก? ",
    confirm: "OK",
    cancel: "ยกเลิก",
    nomore: "ไม่มีข้อมูลอีกต่อไป",
    evelPrice: "ราคาเฉลี่ย",
  },
  // 资产
  asset: {
    confirmhuazhuan: "ยืนยันการโอนหรือไม่",
    assets: "สินทรัพย์",
    currency_account: "บัญชีเหรียญ",
    lever_account: "บัญชีเลเวอเรจ",
    fince_account: "บัญชี",
    change_account: "บัญชีธุรกรรม",
    micro_account: "บัญชีสัญญาที่สอง",
    miscroAccount: "บัญชีสัญญาที่สอง",
    assets_hua: "การโอนเงิน",
    all_assets: "สินทรัพย์รวม",
    currency: "สกุลเงิน",
    canuse: "มีอยู่",
    frezz: "หยุดนิ่ง",
    conversion: "พับเก็บ",
    charging: "เงินฝาก",
    withdraw: "ถอน",
    address_bind: "ผูกที่อยู่ถอน",
    address_withdraw: "การจัดการที่อยู่ซื้อขาย",
    record: "บันทึก",
    tbrecord: "บันทึกการถอน",
    address_charge: "ที่อยู่สำหรับการเรียกเก็บเงิน",
    address_width: "ที่อยู่ตั๋ว",
    copy: "สำเนา",
    ercode: "คิวอาร์โค้ด",
    reminder: "เคล็ดลับ",
    notcharge: "อย่าเติมเงินที่อยู่ข้างต้นใด ๆ",
    ornone: ",มิฉะนั้นทรัพย์สินจะไม่ได้รับการกู้คืน",
    support:
      "เหรียญรองรับเฉพาะวิธีการส่งแบบง่ายเท่านั้น การใช้วิธีการอื่น (ส่งทั้งหมด) ไม่สามารถให้เครดิตได้ชั่วคราว . ",
    minnum: "จำนวนเหรียญขั้นต่ำ",
    ratenum: "ค่าธรรมเนียม",
    havenum: "จำนวนเข้า",
    from: "จาก",
    to: "ถึง",
    transfer: "รูด",
    tfnum: "จำนวนโอน",
    ptfnum: "กรุณาใส่ค่าต่ำสุด",
    dtfnum: "จำนวนจังหวะ",
    canbalance: "ยอดเงินคงเหลือ",
    sureConfirm: "ยืนยันการโอน",
    moneyRecord: "บันทึกทางการเงิน",
    pNum: "ระบุจำนวนการโอนเงิน",
    leverUse: "มีบัญชีเลเวอเรจ",
    legalUse: "มีบัญชี ",
    changeUselg: "บัญชีเหรียญ",
    changeUse: "บัญชีธุรกรรม",
    microuse: "บัญชีสัญญาที่สอง",
    look: "สำรวจ",
    chargeRecord: "บันทึกสกุลเงินที่เรียกเก็บ",
    status: "สถานะการติดตาม",
    noopen: "ฟีเจอร์นี้ยังไม่เปิด",
    enterAdderses: "กรุณาป้อนที่อยู่เหรียญ",
    enterNum: "กรุณากรอกจำนวนเหรียญ",
    lessMin: "จำนวนเหรียญที่ป้อนน้อยกว่าขั้นต่ำ",
    tips01:
      "อย่าเติมเงินสินทรัพย์อื่นใดไปยังที่อยู่ข้างต้น มิฉะนั้น ทรัพย์สินจะไม่ได้รับการกู้คืน",
    tips02:
      "สกุลเงินรองรับเฉพาะวิธีการส่งแบบธรรมดา การใช้วิธีการอื่น (ส่งทั้งหมด) สำหรับสกุลเงินไม่สามารถคิดได้ชั่วคราว ",
    beizhu: "หมายเหตุ",
    pbeizhu: "กรุณาป้อนหมายเหตุ",
    add: "เพิ่ม",
    addressList: "รายการที่อยู่",
    delete: "ลบ",
    norec: "ไม่มีบันทึก",
    selectCurrency: "เลือกสกุลเงิน",
    chainType: "แบบลูกโซ่",
    commissionLibrary: "ห้องสมุดคณะกรรมาธิการ",
  },
  // 账户设置
  set: {
    mycode2: "รหัสอนุญาตของฉัน",
    copycode2: "คัดลอกรหัสการให้สิทธิ์",
    uaccont: "ระดับความปลอดภัยของบัญชีของคุณ:",
    strong: "แข็งแกร่ง",
    middle: "กลาง",
    weak: "อ่อน",
    min: "ต่ำ",
    heigh: "สูง",
    complete: "กรอกข้อมูลเพิ่มเติมเพื่อความปลอดภัยของบัญชี",
    mycode: "รหัสเชิญของฉัน",
    copycode: "คัดลอกรหัสเชิญ",
    bindphone: "ผูกกับโทรศัพท์",
    bindemail: "ผูกกล่องจดหมาย",
    loginpwd: "รหัสในการลงชื่อเข้าใช้",
    noBind: "หลุด",
    binds: "ผูกพัน",
    bind: "ผูกกับ",
    binded: "ผูก",
    net: "บัญชีอินเทอร์เน็ตมีความเสี่ยงที่จะถูกขโมย ขอแนะนำให้คุณเปลี่ยนรหัสผ่านเป็นระยะเพื่อปกป้องบัญชีของคุณ ",
    reset: "แก้ไข",
    setPsw: "ตั้งรหัสผ่านการทำธุรกรรมเพื่อความปลอดภัยของการทำธุรกรรม ",
    goSet: "ไปที่การตั้งค่า",
    bindAccount: "ผูกบัญชีแลกของรางวัล",
    duihuan: "ผูกบัญชีเพื่อแลกคะแนน",
    copysuccess: "คัดลอกสำเร็จ",
    copyfail: "การคัดลอกล้มเหลว",
    recopy: "กรุณาคัดลอกอีกครั้ง",
    account: "บัญชี",
    detail: "รายละเอียด",
    val: "จำนวน",
    forgetPsw: "ลืมรหัสผ่าน",
    code: "รหัสยืนยัน",
    getCode: "รับรหัส",
    setPsw: "ตั้งรหัสผ่าน",
    enterPsw: "กรุณาใส่รหัสผ่าน",
    pswFalse: "รหัสผ่านที่ป้อนสองครั้งไม่สอดคล้องกัน",
    enterPswagain: "กรุณาป้อนรหัสผ่านของคุณอีกครั้ง",
    jsetPsw: "ตั้งรหัสผ่านการทำธุรกรรม",
    jenterPsw: "กรุณาป้อนรหัสผ่านการทำธุรกรรม",
    jenterPswagain: "กรุณาป้อนรหัสผ่านการทำธุรกรรมอีกครั้ง",
    enterAccount: "กรุณาป้อนบัญชี",
    enterCode: "กรุณาป้อนรหัสยืนยัน",
    accountFalse: "บัญชีโทรศัพท์หรืออีเมลที่คุณป้อนไม่เป็นไปตามกฎ!",
    second: "ครั้งที่สอง",
    sendCode: "ส่ง",
    sendsucc: "ส่งสำเร็จ",
    enterPswTwo: "กรุณาใส่รหัสผ่านสองครั้ง",
    rest: "ที่เหลืออยู่",
    yes: "ใช่",
    no: "ไม่",
    yorn: "ตั้งรหัสผ่านการทำธุรกรรม",
    authenticate: "กรุณาตรวจสอบสิทธิ์",
  },
  // 身份认证
  auth: {
    identity: "การรับรองความถูกต้อง",
    name: "ชื่อ",
    idcard: "เอกสารประจำตัว",
    upimg:
      "โปรดอัปโหลดรูปถ่ายของเอกสารระบุตัวตน ภาพแรกคือด้านหน้า ภาพที่สองคือด้านหลัง และภาพที่สามคือภาพถ่ายด้านหน้าของเอกสารระบุตัวตนแบบมือถือ ",
    submit: "ส่ง",
    auditing: "ตรวจสอบ...",
    certified: "รับรอง!",
    pname: "กรุณากรอกชื่อ",
    pidcard: "กรุณากรอกหมายเลขประจำตัวประชาชน",
    pimg: "โปรดอัปโหลดรูปภาพใบรับรอง!",
  },
  // 收款方式
  seting: {
    pmethod: "วิธีการชำระเงิน",
    truename: "ชื่อจริง",
    opening: "ชื่อธนาคาร",
    bank: "หมายเลขบัตรธนาคาร",
    alipay: "บัญชีอาลีเพย์",
    wename: "ชื่อเล่น",
    wechat: "บัญชี",
    pname: "กรุณาใส่ชื่อจริงของคุณ",
    popen: "กรุณากรอกชื่อธนาคาร",
    pcard: "กรุณาใส่หมายเลขบัตรธนาคาร",
    palipay: "กรุณาป้อนบัญชี Alipay",
    Pwname: "กรุณาป้อนชื่อเล่น WeChat",
    pwaccount: "กรุณาป้อนบัญชี WeChat",
    pimg1: "รหัสคอลเลกชัน Wechat",
    pimg2: "รหัสการชำระเงิน Alipay",
  },
  // 帮助中心
  news: {
    seeall: "ดูทั้งหมด",
    helpcenter: "ศูนย์ช่วยเหลือ",
    back: "กลับคืน",
  },
  //登录
  login: {
    welcome: "ยินดีต้อนรับสู่การเข้าสู่ระบบ",
    phoneLogin: "มือถือ",
    emailLogin: "กล่องจดหมาย",
    account: "บัญชีผู้ใช้",
    psw: "รหัสผ่าน",
    login: "เข้าสู่ระบบ",
    nouser: "ยังไม่ได้เป็นผู้ใช้ Besencexchange ใช่ไหม? ",
    goRegister:
      "ลงทะเบียนตอนนี้และเริ่มซื้อขายบนแพลตฟอร์มการซื้อขายสินทรัพย์ดิจิทัลชั้นนำของโลก",
    registerFree: "ลงทะเบียนฟรี",
    psw6: "รหัสผ่านต้องไม่ต่ำกว่า6หลัก",
  },
  register: {
    register: "ลงทะเบียน",
    phoneRegister: "มือถือ",
    emailRegister: "กล่องจดหมาย",
    country: "สัญชาติ",
    enterPhone: "กรุณากรอกหมายเลขโทรศัพท์",
    enterEmail: "กรุณาป้อนกล่องจดหมาย",
    psw16: "รหัสผ่านอยู่ระหว่าง 6-16หลัก",
    inviteCode: "รหัสการเชิญ",
    sel: "จำเป็นเติม",
    sel2: "ไม่ต้องการ",
    read: "ฉันได้อ่านและยอมรับ",
    xieyi: "ข้อตกลงการใช้",
    tips01:
      "ห้ามแก้ไขข้อมูลสัญชาติหลังการลงทะเบียน โปรดแน่ใจว่าได้เลือกถูต้องแล้ว ",
    tips02: "อีเมลยืนยันอาจถูกระบุอย่างไม่ถูกต้องว่าเป็นสแปม โปรดตรวจสอบ ",
    tips03: "โปรดบันทึกบัญชี Besencexchange และรหัสผ่านสำหรับเข้าสู่ระบบของคุณ ",
    tips04: "อย่าใช้รหัสผ่านเข้าสู่ระบบเดียวกันกับเว็บไซต์อื่น ",
    emailFalse: "กล่องจดหมายที่คุณป้อนไม่ตรงตามกฎ",
  },
  // 积分兑换
  jc: {
    title: "แพลตฟอร์ม JC Convertible Digital Assets BEAU",
    balance: "สมดุล",
    cannum: "ปริมาณ JC ที่มีอยู่",
    new: "ราคาล่าสุด",
    exnum: "ปริมาณการแลกเปลี่ยน",
    pnum: "โปรดป้อนหมายเลข JC",
    canex: "ปริมาณ BEAU ที่ปรับเปลี่ยนได้",
    exnow: "แลกเปลี่ยน",
    record: "บันทึกการแลกเปลี่ยน",
    exprice: "ราคาแลกเปลี่ยน",
    extime: "เวลาแลกเปลี่ยน",
    not: "จำนวนปริพันท์ที่มีอยู่ไม่เพียงพอ",
    usenum: "ใช้ปริมาณ JC",
    out: "ทางออก",
    gotd: "กับการค้า",
  },
  coin: {
    manage: "การเงิน",
    total: "เงินฝากทั้งหมด",
    bao: "เงินฝาก",
    mybao: "เงินฝากของฉัน",
    profit: "รายได้โดยประมาณ",
    cuntime: "เวลาฝาก",
    endtine: "เวลาครบกำหนด",
  },
  frame: {
    a: "คุณมีสถานะการถอนเงินใหม่กรุณาคลิกเพื่อดู",
    b: "ยกเลิก",
    c: "ตัดสิน",
    con: "เรียน ผู้ใช้บริการ เนื่องจากมีสมาชิกจำนวนมากที่ซื้อขายในศูนย์ซื้อขาย จะมีการอัพเดทบัญชีธนาคารเป็นระยะๆ เพื่อความปลอดภัยของเงินของผู้ใช้บริการ โปรดติดต่อฝ่ายบริการลูกค้าออนไลน์ของศูนย์ซื้อขาย เพื่อรับข้อมูลล่าสุดบัญชีธนาคารก่อนโอนทุกครั้ง ขอให้ชีวิตมีความสุข",
  },
  team: {
    myteam: "ทีมของฉัน",
    ztnum: "หมายเลขกดโดยตรง",
    activenum: "จำนวนสมาชิกในทีมที่ใช้งานอยู่",
    profit: "รายได้",
    back: "ผลตอบแทนค่าคอมมิชชั่น",
    cblog: "บันทึกการชาร์จ",
    bblog: "บันทึกสกุลเงิน",
  },
  // k线
  kline: {
    text1: "เวลา",
    text2: "1นาที",
    text3: "5นาที",
    text4: "15นาที",
    text5: "30นาที",
    text6: "1ชั่วโมง",
    text7: "1วัน",
    text8: "1อาทิตย์",
    text9: "1เดือน",
  },
  // 秒合约
  miscro: {
    trade: "ธุรกรรม",
    buyPrice: "ราคาซื้อ",
    finshPrice: "ราคาซื้อขาย",
    loss: "ประมาณการกำไรขาดทุน",
    times: "นับถอยหลัง",
    mode: "โหมดการทำธุรกรรม",
    num: "ปริมาณการเปิด",
    rate: "อัตรากำไร",
    up: "ซื้อ",
    down: "ซื้อหรือตก",
    openNum: "กรุณาใส่จำนวนเปิด",
    success: "การสั่งซื้อสำเร็จ!",
    c2c: "บัญชีคำสั่ง",
    complaint: "ข้อเสนอแนะการร้องเรียน",
    reply: "โปรดเขียนคำถามของคุณและเราจะตอบกลับโดยเร็วที่สุด...",
    complaintList: "รายการข้อเสนอแนะการร้องเรียน",
    complaintReply: "ตอบกลับ:",
    complaintDescription: "กรุณาป้อนคำอธิบาย",
    resetpwd: "แก้ไขรหัสผ่าน",
    foundedOn: "ก่อตั้งขึ้นเมื่อ",
    commonProblem: "ปัญหาทั่วไป",
    statement: "การตีคว่มคำสั่ง",
    about: "เกี่ยวกับ Besencexchange",
    everyone: "ทุกคนเป็น CEO",
    program: "โปรแกรมพาร์ทเนอร์ระดับโลกของ Besencexchange",
    program2: "พันธมิตร",
    myMine: "ของฉัน:",
    friend: "เพื่อนของฉัน:",
    myRank: "อันดับของฉัน:",
    accumulated: "ค่าคอมมิชชั่นสะสม:",
    copyLinks: "สำเนา",
    moneyVein: "ความสัมพันธ์ของผู้คนเปลี่ยนไปเป็นเส้นทางการเงิน",
    example: "ตัวอย่างค่าคอมมิชชั่น",
    enterQuantity: "กรุณากรอกจำนวน",
    contractBalance: "ยอดเงินในบัญชีสัญญา",
    submitRepeatedly: "การส่งโปรดอย่าส่งซ้ำ",
    alipayCode: "รหัสการชำระเงิน Alipay",
    wechatCode: "รหัสใบเสร็จรับเงิน Wechat",
    realPrice: "ราคาเรียลไทม์",
    currencyExchange: "แลกเปลี่ยนเงินตรา",
    currencyExchangeIn: "แลกเปลี่ยนเงินตราสกุลเงิน",
    cashableBalance: "ยอดคงเหลือที่สามารถถอนได้：",
    minimumCashable: "เงินสดขั้นต่ำที่สามารถถอนได้：",
    maximumCashable: "เงินสดสูงสุดที่สามารถแลกได้：",
    automaticallys:
      "หลังจากคลิกที่การแลกเปลี่ยน จะเสร็จสมบูรณ์โดยอัตโนมัติและยกเลิกได้",
    match: "จับคู่",
    title: "การแปลงสภาพสินทรัพย์",
    holdAssets: "การถือครองทรัพย์สิน",
    dangerousCurrency: "ถือสกุลเงินที่มีความเสี่ยง",
    convertibleQuantity: "ปริมาณแปลงสภาพ",
    currencyExchanges: "อัตราแลกเปลี่ยนเงินตราต่างประเทศ：",
    insuranceCurrency: "สกุลเงินประกัน",
    insuranceType: "ประเภทประกัน",
    contractAsset: "สัญญาประกันทรัพย์สิน",
    warehouses: "จำนวนคลังสินค้า",
    availableAssets: "ทรัพย์สินที่มีอยู่:",
    insuredAssets: "ทรัพย์สินเอาประกันภัย:",
    insuredAssets1: "ทรัพย์สินเอาประกันภัย",
    insuranceAssets: "ทรัพย์สินเอาประกันภัย",
    purchaseInsurance: "ซื้อประกัน",
    insuranceClaims: "การเรียกร้องประกัน",
    insuranceCancellation: "การยกเลิกประกัน",
    coinWallet: "กระเป๋าเงินเหรียญประกัน",
    bmbWallet: "กระเป๋าเงิน HAP",
    cumulativeCoins: "เหรียญสะสม：",
    availableQuantity: "จำนวนที่มีจำหน่าย:",
    rawCurrency: "บันทึกสกุลเงินดิบ",
    contractInsurance: "สัญญาค้ำประกัน",
    tenThousand: "10,000",
    runningLow: "ขออภัย เครดิตของคุณใกล้หมดแล้ว",
    purchase: "ปริมาณที่คุณป้อนไม่เป็นไปตามกฎ โควต้าการซื้อของคุณคือ",
    reach: "เข้าถึง",
    between: "ระหว่าง",
    onlyEnter: "เข้าได้เท่านั้น",
    integersBetween: "จำนวนเต็มระหว่าง",
    notReturned:
      "คลิกเพื่อซื้อประกันตามความเข้าใจโดยละเอียดเกี่ยวกับสนธิสัญญาประกันภัยและตกลงว่าคลังสินค้าจะมีผลใช้บังคับโดยอัตโนมัติไม่สามารถคืนได้",
    settled:
      "เมื่อทรัพย์สินที่เอาประกันภัยสูญหายและไม่สามารถสั่งซื้อได้ ให้ถือว่าค่าสินไหมทดแทนประกันภัยเป็นอันระงับ",
    profitable: "เมื่อทรัพย์สินมีกำไร",
    terminated: "ในขณะนั้นประกันจะสิ้นสุดลงโดยอัตโนมัติ",
    automatically:
      "เมื่อทรัพย์สินที่เอาประกันภัยเสีย 50% จะต้องยื่นขอเคลมประกัน มิฉะนั้น จะซื้อขายไม่ได้ เมื่อกำไร 100% ประกันจะยกเลิกสัญญาโดยอัตโนมัติ โกดังจ่ายได้เพียงวันละสองครั้ง มากกว่าสองครั้ง t+1",
    termination:
      "หลังจากสิ้นสุดสัญญาประกันแล้ว ทรัพย์สินที่เอาประกันภัยสามารถแปลงได้ ภายหลังการบอกเลิกสัญญา ทรัพย์สินที่เอาประกันภัยถือว่าผิดสัญญา และคลังสินค้าจะถูกหักล้างโดยอัตโนมัติ",
    just: "แค่",
    back: "กลับ",
    lowestNumber: "จำนวนต่ำสุดคือ",
    confirmExchange: "คุณยืนยันการแลกเปลี่ยนหรือไม่",
    contractValuation: "การประเมินมูลค่าทรัพย์สินทางบัญชีตามสัญญา",
    secondValuation: "การประเมินมูลค่าทรัพย์สินบัญชีสัญญาที่สอง",
    falshValuation: "การประเมินมูลค่าทรัพย์สินในบัญชีแฟลช",
    c2cValuation: "การประเมินมูลค่าทรัพย์สินของบัญชีคำสั่ง",
    recordWithdrawal: "บันทึกการถอนเงิน",
    category: "หมวดหมู่",
    safetyCenter: "ศูนย์ความปลอดภัย",
    safeText1:
      "การลงทะเบียน การแก้ไขรหัสผ่าน และการตั้งค่าความปลอดภัยในการรับ SMS ที่ตรวจสอบแล้ว",
    safeText2:
      "บัญชีอินเทอร์เน็ตมีความเสี่ยงที่จะถูกขโมย ขอแนะนำให้คุณเปลี่ยนรหัสผ่านเป็นประจำเพื่อป้องกันความปลอดภัยของบัญชี",
    flashTrading: "การซื้อขายแฟลช",
    assetCenter: "ศูนย์สินทรัพย์",
    promotionCode: "รหัสโปรโมชั่นของฉัน",
    loginAgain: "การเข้าสู่ระบบเกินเวลากำหนดกรุณาเข้าสู่ระบบใหม่อีกครั้ง",
    text10: "ราคาตามเวลาจริงตาม HAP",
    text11: "รหัสอนุญาติ",
  },
};

// WEBPACK FOOTER //
// ./src/lang/th.js
